import type { INotificationActionsAccessRequestProps } from '../../types';
import { AcceptRequestButton } from './AcceptRequestButton';

export function AccessRequestAction({
	notification,
	applyAccessRequest,
	accessRequestApplied,
}: INotificationActionsAccessRequestProps) {
	if (!notification.request?.id) {
		return null;
	}

	const isApplied = notification.request?.applied || accessRequestApplied;

	return (
		<AcceptRequestButton
			applied={isApplied}
			onAccept={() => applyAccessRequest({ id: notification.request!.id })}
		/>
	);
}
